// extracted by mini-css-extract-plugin
module.exports = {"header":"screen-error-module__header___1NaHx","link":"screen-error-module__link___7Cd4c"};